export default __webpack_public_path__ + "static/media/AetherPhoto2.85e8fa36.jpg";